import { UserStatus } from '@synergy/models';

const translationObject: { [Key in UserStatus]: string } = {
    [UserStatus.SupplierAdmin]: 'app.user.status.supplierAdmin',
    [UserStatus.SupplierUser]: 'app.user.status.supplierUser',
    [UserStatus.NoUser]: 'app.user.status.noUser',
    [UserStatus.Locked]: 'app.user.status.locked',
    [UserStatus.NotActivated]: 'app.user.status.notActivated',
    [UserStatus.ShopAdmin]: '',
    [UserStatus.ShopUser]: '',
};

export const getUserStatusTranslationId = (userStatus: UserStatus): string => {
    return translationObject[userStatus];
};
